import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { FAQ } from "../../data/site";
import { Reveal, SectionHead } from "./Reveal";

export default function Faq() {
  return (
    <section id="sss" className="relative bg-[#08072a] py-24 md:py-36" data-testid="faq-section">
      <div className="mx-auto max-w-7xl px-5 md:px-10 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <SectionHead kicker="05 · SSS" title={<>Merak<br />edilenler.</>} testid="faq-title" />
        </div>
        <Reveal className="lg:col-span-7">
          <Accordion type="single" collapsible className="border-t border-white/10">
            {FAQ.map((f, i) => (
              <AccordionItem key={f.q} value={`f${i}`} className="border-white/10">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-display text-base md:text-xl font-semibold hover:no-underline hover:text-[#8a8dff]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-base text-[#c9c6f0] leading-relaxed pb-6">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
